/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S4_P3Inputs */

const tr_iade_iptal_s4_p3 = /** @type {(inputs: Iade_Iptal_S4_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel, seçilen dönem boyunca sürekli olarak sunulan bir hizmet olduğundan, cayma hakkının istisnası yalnızca Madde 15/1-h'ye dayanır; Madde 15/1-ğ (elektronik ortamda anında ifa edilen hizmetler) bu Sözleşme bakımından uygulanmaz. Yukarıdaki açık onay her satın almada alınır.`)
};

const en_iade_iptal_s4_p3 = /** @type {(inputs: Iade_Iptal_S4_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As ShopPanel is a service provided continuously throughout the selected period, the exception to the right of withdrawal rests solely on Article 15/1-h; Article 15/1-ğ (services performed instantly in an electronic environment) does not apply to this Agreement. The express consent above is obtained at each purchase.`)
};

const de_iade_iptal_s4_p3 = /** @type {(inputs: Iade_Iptal_S4_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da ShopPanel ein während des gewählten Zeitraums fortlaufend erbrachter Dienst ist, stützt sich die Ausnahme vom Widerrufsrecht allein auf Artikel 15/1-h; Artikel 15/1-ğ (elektronisch sofort erbrachte Dienstleistungen) ist auf diesen Vertrag nicht anwendbar. Die obige ausdrückliche Zustimmung wird bei jedem Kauf eingeholt.`)
};

const ru_iade_iptal_s4_p3 = /** @type {(inputs: Iade_Iptal_S4_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поскольку ShopPanel — услуга, оказываемая непрерывно в течение выбранного периода, исключение из права на отказ основывается исключительно на статье 15/1-h; статья 15/1-ğ (услуги, оказываемые мгновенно в электронной среде) к настоящему Договору не применяется. Указанное выше прямое согласие получается при каждой покупке.`)
};

/**
* | output |
* | --- |
* | "As ShopPanel is a service provided continuously throughout the selected period, the exception to the right of withdrawal rests solely on Article 15/1-h; Arti..." |
*
* @param {Iade_Iptal_S4_P3Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s4_p3 = /** @type {((inputs?: Iade_Iptal_S4_P3Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S4_P3Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s4_p3(inputs)
	if (locale === "de") return de_iade_iptal_s4_p3(inputs)
	if (locale === "ru") return ru_iade_iptal_s4_p3(inputs)
	return tr_iade_iptal_s4_p3(inputs)
});